// extracted by mini-css-extract-plugin
export default {"noPermissions":"noPermissionWidget_noPermissions__CC1UV"};